import api from '../auth';
const slug = 'api/mms/';

const MmService = () => {
    const getMms = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getMmsLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getMm = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteMm = (id) => {
        return api
            .delete(slug + `mm/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createMm = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateMm = (id, data) => {
        return api.put(slug + `mm/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyMm = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    const kreirajNalog = (id, data) => {
        return api.post(slug + `createnalog/${id}/`, data).then((res) => res.data);
    };

    const ukloniDodelu = (id, data) => {
        return api.post(slug + `uklonidodelu/${id}/`, data).then((res) => res.data);
    };

    const barcodeSearch = (barcode) => {
        return api.get(slug + `barcode/${barcode}/`).then((res) => res.data);
    };

    const uploadUgiSkica = (id, data) => {
        return api
            .post(slug + `mm/${id}/upload-ugi-skica`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((res) => res.data);
    };

    const uploadUgovor = (id, data) => {
        return api
            .post(slug + `mm/${id}/upload-ugovor`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((res) => res.data);
    };

    return {
        getMms,
        getMmsLazy,
        getMm,
        deleteMm,
        createMm,
        updateMm,
        getOptions,
        copyMm,
        kreirajNalog,
        ukloniDodelu,
        barcodeSearch,
        uploadUgiSkica,
        uploadUgovor
    };
};

export default MmService;
